
export default {
    name: 'ClaimPromoCodeBox',
    data() {
        return {
            loading: false,
            code: null,
            checkModal: false,
            checkData: {},
        }
    },
    methods: {
        async onClaimPromotionCode() {
            if (!this.code) return null
            this.loading = true
            if (this.code) {
                const res = await this.$store.dispatch(
                    'themes/promotion/claimPromotionCode',
                    { code: this.code?.trim(), walletPopupStatus: 1 }
                )
                if (!res) return (this.loading = false)
                if (JSON.parse(res?.display_popup) === true) {
                    this.checkData = res
                    this.checkModal = true
                } else if (JSON.parse(res?.display_popup) === false) {
                    this.code = null
                    this.$toast.success(this.tl('claimPromotionCodeSucceeded'))
                }
                this.loading = false
            }
        },
    },
}
